export default __webpack_public_path__ + "static/media/teamwork_whitecard.ab257bde.svg";